/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SubjectInputs */

const en_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

const de_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreff`)
};

const fr_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sujet`)
};

const es_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asunto`)
};

const it_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggetto`)
};

const nl_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderwerp`)
};

const pl_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temat`)
};

const fi_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aihe`)
};

const da_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emne`)
};

const sv_feedback_subject = /** @type {(inputs: Feedback_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ämne`)
};

/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Feedback_SubjectInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_subject = /** @type {((inputs?: Feedback_SubjectInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SubjectInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_subject(inputs)
	if (locale === "fr") return fr_feedback_subject(inputs)
	if (locale === "es") return es_feedback_subject(inputs)
	if (locale === "it") return it_feedback_subject(inputs)
	if (locale === "nl") return nl_feedback_subject(inputs)
	if (locale === "pl") return pl_feedback_subject(inputs)
	if (locale === "fi") return fi_feedback_subject(inputs)
	if (locale === "da") return da_feedback_subject(inputs)
	if (locale === "sv") return sv_feedback_subject(inputs)
	return en_feedback_subject(inputs)
});